<script setup lang="ts">
import InfoStripe from '@/components/common/info-stripe.vue';
import NewReleasesModal from '@/components/new-release/new-releases-modal.vue';
import { useAuthWatcher } from '@/composables/useAuthWatcher';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import MainFooter from './MainFooter.vue';
import MainHeader from './MainHeader.vue';

import { useUserStore } from '../stores/user';

useAuthWatcher();
const route = useRoute();
const { userProfile, hasClosedReleasesModal, selectedAccount } = storeToRefs(useUserStore());
const { setClosedReleasesModal } = useUserStore();

const showHeader = computed(() => {
  return !(route.meta['usesExitNavBar'] === true) && !showNewReleaseModal.value;
});

const showNewReleaseModal = computed<boolean>(() => {
  return !hasClosedReleasesModal.value && userProfile.value?.user.latestFeatureRelease?.externalId !== undefined;
});

function closeNewReleaseModal(): void {
  setClosedReleasesModal(true);
}
</script>

<template>
  <div class="main-layout">
    <InfoStripe v-if="selectedAccount" />
    <MainHeader v-if="showHeader" />
    <div class="scroll-wrapper">
      <main class="main-content">
        <RouterView />
      </main>
    </div>
    <MainFooter />
    <NewReleasesModal
      v-if="showNewReleaseModal"
      :feature-release="userProfile?.user.latestFeatureRelease"
      v-on:hide-modal="closeNewReleaseModal" />
  </div>
</template>

<style lang="scss" scoped>
.main-layout {
  min-height: 100vh;
  flex-flow: column;
  flex-direction: column;
  display: flex;

  .scroll-wrapper {
    display: flex;
    flex-direction: column;
    flex: 1;

    .main-content {
      width: 100%;
      flex-grow: 1;
      padding: 0;
    }
  }
}
</style>
